import {
    createDBInputValidation,
    createDBEntityValidator,
} from 'shared/db/validation/common';
import { Logger } from 'shared/db/validation/databaseInput';
import { createHorsesSchemas } from 'shared/db/validation/schema/horses';
import { Validator } from 'shared/db/validation/validator';
import { HorseRawRecord, HorseUpdateRawRecord } from 'shared/types/Horses';
import { DeleteRawRecord } from 'shared/types/rawRecordFields';
import { HorsesDBValidation } from 'shared/types/validation';

import { createLoggerFor } from '@/services/logger';
import { getValidationStrategy } from '@/utils/validations';

const schemas = createHorsesSchemas();

const addValidator = createDBEntityValidator<HorseRawRecord>(schemas.add);
const updateValidator = createDBEntityValidator<HorseUpdateRawRecord>(
    schemas.update,
);
const deleteValidator = createDBEntityValidator<DeleteRawRecord>(
    schemas.delete,
);

const softValidation = {
    logger: createLoggerFor('db-validation-horses'),
    hardErrorFields: [],
};

const validationStrategy = getValidationStrategy(softValidation);

export const createHorsesInputValidation = <T extends Record<string, unknown>>(
    validator: Validator<T>,
    softValidation?: {
        logger: Logger;
        hardErrorFields: string[];
    },
) => createDBInputValidation<T>(validator, softValidation);

export const horsesInputValidation: HorsesDBValidation = {
    add: createHorsesInputValidation(addValidator, validationStrategy),
    update: createHorsesInputValidation(updateValidator, validationStrategy),
    delete: createHorsesInputValidation(deleteValidator, validationStrategy),
};
